import {
  Tooltip,
  Card,
  Typography,
  Input,
  Button,
  Pagination,
  Switch,
  Form,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SortingArrow from "../../Common/SortingArrow";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { checkPermissionAction } from "../../utils/helper/utils";
let timer = null;
const ManagePackagingType = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);  
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const selectedLanguage = localStorage.getItem("lang") || "en";

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const [itemData, setItemData] = useState(0);
  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_PACKAGING_TYPE?.UPDATE + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Packaging deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllPackaging();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };
  const getAllPackaging = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        language: selectedLanguage,
      };
      let response = await globalRequest(
        Apis.MANAGE_PACKAGING_TYPE.GET,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllPackaging();
    }, 400);
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_PACKAGING_TYPE?.UPDATE + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Packaging type active successfully";
        if (item.status === "active")
          msg = "Packaging type inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllPackaging();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Manage Packaging Type
            </Typography>
          </div>
          <div>
            <Search
              placeholder="Search by Packaging Type"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("search", value);
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
              style={{
                width: 250,
              }}
              className="mx-1.5 cursor-pointer my-3 sm:my-0"
            />
            <Button
              type="primary"
              size={14}
              icon={<PlusOutlined />}
              className="mx-1.5 cursor-pointer"
              onClick={() => navigate("/add-packaging-type")}
            >
              Add Packaging Type
            </Button>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Name{" "}
                  <SortingArrow onSort={(order) => handleSort("name", order)} />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Volume{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("volume", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Height{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("height", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Width{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("width", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Length{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("length", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.locales?.find(l => l.languageCode === selectedLanguage)?.name ||
                       item?.locales?.find(l => l.languageCode === "en")?.name ||
                      "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {Number(item?.volume.toFixed(2))} cm<sup>3</sup>
                    </td>
                    <td className="px-3 py-4 vertical-top">{item?.height}</td>
                    <td className="px-3 py-4 vertical-top">{item?.width}</td>
                    <td className="px-3 py-4 vertical-top">{item?.length}</td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Packaging Type",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Packaging Type",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/edit-packaging-type/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Packaging Type",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Packaging Type",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Packaging Type",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Packaging Type?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
        okText="Delete"
      />
    </>
  );
};
export default ManagePackagingType;
